<p-toast position="bottom-right"></p-toast>
<div [ngClass]="'cc-rich-field'">
  <p-table #table styleClass="crystal-table"
           [value]="formRecords"
           [scrollable]="true"
           [resizableColumns]="true">
    <ng-template pTemplate="header">
      <tr>
        <th *ngFor="let columnDef of formRichFieldConfig.tableConfigs"
            [style.width]="columnDef.width ? columnDef.width+'px' : '110px'"
            [style.flex-basis]="columnDef.width ? columnDef.width+'px' : '110px'">
          <div *ngIf="columnDef.field" class="justify-content-between align-items-center">
            {{columnDef.label ? columnDef.label : 'page.' + this.transPartKey + '.form.' + columnDef.field | translate}}
          </div>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-record let-rowIndex="rowIndex">
      <tr>
        <td *ngFor="let columnDef of formRichFieldConfig.tableConfigs; let i = index"
            [style.width]="columnDef.width ? columnDef.width+'px' : '110px'"
            [style.flex-basis]="columnDef.width ? columnDef.width+'px' : '110px'"
            (click)="copiedToClipboard()"
            [cdkCopyToClipboard]="columnDef.mapId?fieldValueMap['mapId-' + i + '_' + rowIndex]:record[columnDef.field]">
          <span
            *ngIf="columnDef.field && !columnDef.command && !columnDef.format && !columnDef.mapId
                    && columnDef.type!='DATE'&& columnDef.type!='DATETIME'&& columnDef.type!='TIME'&& columnDef.type!='NUMERIC'"
            [title]="record[columnDef.field]">
            {{record[columnDef.field]}}
          </span>
          <span *ngIf="columnDef.field && (columnDef.type==='DATE')"
                [title]="(columnDef.mapId?fieldValueMap['mapId-' + i + '_' + rowIndex]:record[columnDef.field])
            | date:columnDef.format?columnDef.format:'dd/MM/y'">
            {{(columnDef.mapId?fieldValueMap['mapId-' + i + '_' + rowIndex]:record[columnDef.field])
            | date:columnDef.format?columnDef.format:'dd/MM/y'}}
          </span>
          <span *ngIf="columnDef.field && (columnDef.type==='DATETIME')"
                [title]="(columnDef.mapId?fieldValueMap['mapId-' + i + '_' + rowIndex]:record[columnDef.field])
            | date:columnDef.format?columnDef.format:'hh:mm dd/MM/y'">
            {{(columnDef.mapId?fieldValueMap['mapId-' + i + '_' + rowIndex]:record[columnDef.field])
            | date:columnDef.format?columnDef.format:'hh:mm dd/MM/y'}}
          </span>
          <span *ngIf="columnDef.field && (columnDef.type==='TIME')"
                [title]="(columnDef.mapId?fieldValueMap['mapId-' + i + '_' + rowIndex]:record[columnDef.field])
             | date:columnDef.format?columnDef.format:'hh:mm'">
            {{(columnDef.mapId?fieldValueMap['mapId-' + i + '_' + rowIndex]:record[columnDef.field])
            | date:columnDef.format?columnDef.format:'hh:mm'}}
          </span>
          <span *ngIf="columnDef.field && (columnDef.type==='NUMERIC')"
                [title]="(columnDef.mapId?fieldValueMap['mapId-' + i + '_' + rowIndex]:record[columnDef.field])
             | number:columnDef.format ? columnDef.format:'1.0-7'">
            {{(columnDef.mapId?fieldValueMap['mapId-' + i + '_' + rowIndex]:record[columnDef.field])
            | number:columnDef.format ? columnDef.format : '1.0-7'}}
          </span>
          <span *ngIf="columnDef.field && columnDef.mapId
                   && columnDef.type!='DATE'&& columnDef.type!='DATETIME'&& columnDef.type!='TIME'&& columnDef.type!='NUMERIC'"
                [innerHTML]="fieldValueMap['mapId-' + i + '_' + rowIndex]"
                [title]="fieldValueMap['mapId-' + i + '_' + rowIndex]">
          </span>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
